(function (angular) {

  angular.module("alk.marketing", []);

})(window.angular);


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-marketing/module.js